<template>
	<div :class="{ collapsed: collapsed }" class="sentence-preview">
		<!-- er i path {{previewedSentenceInSubtree}} -->
		<!-- <div v-if="!conditions.length && !variants.length" style="padding: 10px;"><i class="fa-light fa-exclamation-circle" style="margin-right: 10px"></i>Niveau uden indhold!</div> -->
		<div @click="onToggleCollapsed" class="conditions">
			<div class="toggle-collapse">
				<img :src="!collapsed ? require('@/assets/svg/chevronUp.svg') : require('@/assets/svg/chevronDown.svg')"
				class="caret"/>
			</div>
			<div>
				<condition
						:condition-object=condition
						:key="i"
						v-for="(condition, i) in conditions"
				/>
			</div>
			<i class="condition" v-show="conditions.length == 0">Ingen visningsbetingelser</i>
		</div>
		<div class="variants-and-sentences" v-if="!collapsed">
			<!-- <div :style="{ 'padding-left': conditions.length ? 38 + 'px' : 0 }"> -->
			<ul class="variants">
				<li :class="{ highlight: hasPreviewedSentence && highlightPath[highlightPath.length-1] == index }"
				    :key="index"
				    class="variant"
				    v-for="(variant, index) in variants"
				>
					{{variant | variable($store.getters.combinedVariables, 'name')}}
				</li>
			</ul>
			<sentence-preview
				:depth="depth + 1"
				:highlight-path="highlightPath"
				:key="index"
				:path="[...path, ...index]" :sentence="sentence"
				v-for="(sentence, index) in sentences"
			/>
		</div>
	</div>
</template>

<script>
	import SentencePreview from '@/components/SentencePreview'
	import Condition from '@/components/Condition'
	import EventBus from '@/assets/js/eventBus.js'

	export default {
		name: 'SentencePreview',
		data() {
			return {
				collapsed: false
			}
		},
		props: {
			sentence: {
				type: Object,
				required: true
			},
			depth: {
				type: Number,
				required: true
			},
			highlightPath: {
				type: Array,
				required: true
			},
			path: {
				type: Array,
				required: true
			}
		},
		computed: {
			isLeaf() {
				return !this.conditions.length && !this.variants.length
			},
			variants() {
				return this.sentence.texts || []
			},
			sentences() {
				return this.sentence.sentences || []
			},
			conditions() {
				return this.sentence.conditions || []
			},
			previewedSentenceInSubtree() {
				return (this.highlightPath.slice(0, this.path.length).toString() === this.path.toString())
			},
			hasPreviewedSentence() {
				if (this.highlightPath.length - 1 != this.path.length) return false
				if (!this.sentence.texts || !this.sentence.texts.length) return false
				// test if path is the same
				return (this.highlightPath.slice(0, this.highlightPath.length - 1).toString() === this.path.toString())
			}
		},
		methods: {
			onToggleCollapsed() {
				this.collapsed = !this.collapsed
			}
		},
		watch: {
			highlightPath: {
				immediate: true,
				handler() {
					if (!this.highlightPath) console.log('highlightpath empty')
					if (!this.path) console.log('path empty')
					this.collapsed = !this.previewedSentenceInSubtree
				}
			}
		},
		components: {
			SentencePreview,
			Condition
		},
		mounted() {
			if (this.hasPreviewedSentence) {
				EventBus.$emit('hasPreviewedSentence', this.hasPreviewedSentence)
			}
		}
	}
</script>

<style lang="less">
	// .ql-editor {
	// 	white-space: unset !important;
	// }

	.sentence-preview {
		padding-bottom: 8px;

		+ .sentence-preview {
			margin-bottom: 8px;
		}

		border-bottom: 1px solid #485258;

		&:first-child {
			border-bottom: none;
			padding-top: 0;
		}

		.conditions {
			display: flex;
			align-items: center;

			.toggle-collapse {
				margin-right: 15px;
			}

			.condition {
				flex: 1 1 auto;
			}

			+ .variants-and-sentences {
				margin-top: 8px;
			}
		}

		.variants-and-sentences {
			padding-left: 25px;
		}

		.variants {
			padding-left: 13px;

			.variant {
				color: var(--text-grey-primary);
				padding-left: 0;

				&::before {
					// margin-right: 15px !important;
					position: relative;
					left: -5px;

				}

				&.highlight {
					color: var(--orange-web);
				}

				// margin-left: 0 !important;

				br {
					display: none;
				}
			}
		}
	}
</style>
